module.exports = "/to_the_arctic_for_practice/_next/static/videos/5-e1adb42c27e83e2454596dbe8d78fb0d.mp4";